module.exports = __webpack_public_path__ + "static/img/9.42afa34.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/5/2/2/eng/9.png
// module id = TGnV
// module chunks = 0